import './style.scss'

const Loader = () => <span className="loader" />

export default Loader
